import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LandingPage from '@/pages/LandingPage'
import ConfiguratorPage from '@/pages/ConfiguratorPage'
import DashboardPage from '@/pages/DashboardPage'
import DesignPage from '@/pages/DesignPage'
const ResultPage = () => <div className="bg-surface min-h-screen text-on-surface p-8">Résultat — à implémenter</div>
const AuthCallbackPage = () => <div className="bg-surface min-h-screen text-on-surface p-8">Auth callback — à implémenter</div>
const NotFoundPage = () => <div className="bg-surface min-h-screen text-on-surface p-8 text-center pt-32 text-on-surface-variant">404 — Page introuvable</div>

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/configurator" element={<ConfiguratorPage />} />
        <Route path="/configurator/:step" element={<ConfiguratorPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/designs/:designId" element={<DesignPage />} />
        <Route path="/designs/:designId/result" element={<ResultPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}
